import { PATHS } from "@/lib/content";
import { Icon } from "@/components/common/Icon";

export const SelectStep = ({ journey }) => (
  <>
    <p className="overline">Start from your problem</p>
    <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl">
      Tell us what you need
    </h2>
    <p className="mt-3 max-w-xl text-slate-600">
      No generic forms. Pick the description that fits you, and we'll tailor the next steps.
    </p>
    <div className="mt-8 grid gap-4 md:grid-cols-3">
      {PATHS.map((path) => (
        <button key={path.id} onClick={() => journey.choosePath(path.id)} data-testid={`path-card-${path.id}`}
          className="group flex flex-col items-start rounded-2xl border border-border bg-white p-6 text-left transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:border-blue-500 hover:shadow-xl hover:shadow-blue-600/10">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50 text-blue-600 transition-colors group-hover:bg-blue-600 group-hover:text-white">
            <Icon name={path.icon} className="h-6 w-6" />
          </span>
          <span className="mt-5 font-heading text-lg font-bold text-slate-900">{path.label}</span>
          <span className="mt-2 text-sm leading-relaxed text-slate-500">{path.blurb}</span>
        </button>
      ))}
    </div>
  </>
);